/**
 * Single source of truth for the Parrot API host + path prefix.
 *
 * This is an internal Parrot component talking to an internal Parrot API — there is
 * exactly one deployment, so the URL is baked in rather than configured per consumer.
 * Both the chat endpoint and the chatbot history API hang off this prefix, so a future
 * path migration is a one-line change here.
 */
export const PARROT_API_BASE_URL = "https://prodapi.parrotanalytics.com/parrot-labs/intelligence";
